import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import DateInput from "components/Input/DateInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import styled from "styled-components";
import { scriptText } from "variables/MBM/geb";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postGEBScript, putGEBScript, getMBMAVOBBoxs } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSwitch from "components/Input/CustomSwitch.js";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";
import CodeMirror from '@uiw/react-codemirror';
import { javascript, javascriptLanguage } from "@codemirror/lang-javascript"
import { completeFromList } from '@codemirror/autocomplete';
import { destinationData } from "variables/MBM/lists/schedule";

const customFunctions = [
  {
    label: "SUM",
    type: "text",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, somme les données",
    apply: "'SUM'"
  },
  {
    label: "AVG",
    type: "enum",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, moyenne les données",
    apply: "AVG"
  },
  {
    label: "MAX",
    type: "enum",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, renvoie la donnée la plus grande",
    apply: "MAX"
  },
  {
    label: "MIN",
    type: "enum",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, renvoie la donnée la plus petite",
    apply: "MIN"
  },
  {
    label: "COUNT",
    type: "enum",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, compte les données",
    apply: "COUNT"
  },
  {
    label: "COUNTDISTINCT",
    type: "enum",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, compte le nombre de données différentes",
    apply: "COUNTDISTINCT"
  },
  {
    label: "FIRST",
    type: "enum",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, renvoie la 1ère donnée temporelle",
    apply: "FIRST"
  },
  {
    label: "LAST",
    type: "enum",
    //detail: "(scheduleid, date)",
    info: "Type d'aggrégation, renvoie la dernière donnée temporelle",
    apply: "LAST"
  },
  {
    label: "avob.getScheduleValue",
    type: "function",
    detail: "(scheduleid, date)",
    info: "Récupère une valeur spécifique d'un planning (scheduleid) à une date donnée",
    apply: "avob.getScheduleValue("
  },
  {
    label: "avob.getElementLastValue",
    type: "function",
    detail: "(elementid, maxrange)",
    info: "Renvoie la dernière valeur de l’element “elementid” et jusqu’à “maxrange” minutes avant. Null sinon",
    apply: "avob.getElementLastValue("
  },
  {
    label: "avob.getElementValue",
    type: "function",
    detail: "(elementid, date, maxrange)",
    info: "Renvoie la valeur de l’element “elementid” au plus proche de la date définie “date”, et jusqu’à “maxrange” minutes avant. Null sinon.",
    apply: "avob.getElementValue("
  },
  {
    label: "avob.getElementAggValue",
    type: "function",
    detail: "(elementid, datebegin, dateend, agg)",
    info: "Renvoie la valeur de l’element “elementid” aggrégée par “agg” (AVG, SUM, MAX, MIN, COUNT, COUNTDISTINCT, FIRST, LAST) entre datebegin (>=) et dateend (<)",
    apply: "avob.getElementAggValue("
  },
  {
    label: "avob.writeElementValue",
    type: "function",
    detail: "(elementid, value)",
    info: "Ecrit la valeur “value” pour l’element “elementid”",
    apply: "avob.writeElementValue("
  },
];
// const customAutocomplete = javascriptLanguage.data.of({
//   autocomplete: completeFromList(customFunctions)
// });

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  testButton: {
    color: "#FFFFFF",
    backgroundColor: "#3E8FC6",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#3E8FC6",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function ScriptDialog(props) {

  const { closeModal, refetch, setLoading, wpgroup, currentScript, workspaceid, equipmentdata, fullpointdata } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const { chartIdGroup } = advancedSearchContext;

  const [description, setDescription] = useState(currentScript?.parameters.description || "");
  const [name, setName] = useState(currentScript?.parameters.name || "");
  const [destinationtype, setDestinationtype] = useState(currentScript?.destination?.destinationtype || "avobbox");
  const [avobboxs, setAvobboxs] = useState(currentScript?.destination?.avobboxs || []);
  const [triggers, setTriggers] = useState(currentScript?.triggers || {});
  const [script, setScript] = useState((currentScript?.script && currentScript?.script !== "") ? atob(currentScript.script) : "function AVOBScript()\r\n{\r\n  \r\n}");
  const [customAutocomplete, setCustomAutocomplete] = useState(javascriptLanguage.data.of({ autocomplete: completeFromList(customFunctions) }))

  const onChange = React.useCallback((val, viewUpdate) => {
    console.log('val:', val);
    setScript(val);
  }, []);

  const [boxdata, setBoxdata] = useState([]);

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const classes = useStyles();

  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const selectedBox = () => {
    let selected = boxdata.filter((obj) =>
      avobboxs.includes(obj.id));
    return selected;
  };
  const handleBoxsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setAvobboxs(newArray);
  };
  const handleDestinationtypeChange = (event) => {
    setDestinationtype(event.target.value);
  };

  const handleSubmit = (event) => {
    if (currentScript)
      updateScript(event);
    else
      createScript(event);
  };

  const handleTest = (event) => {
    if (currentScript)
      testScript(false);
    else
      testScript(true);
  };

  useEffect(() => {
    //     {
    //   label: "eq.VanneThermostatique1.consigne",
    //   type: "variable",
    //   //detail: "(elementid, datebegin, dateend, agg)",
    //   info: "",
    //   apply: "684224"
    // }
    console.log(fullpointdata?.length, equipmentdata?.length);
    let pointsscripttmp = [];
    fullpointdata.forEach(element => {
      let id = element.id;
      let ptname = element.name;
      let equipment = element.equipment;
      if (equipment) {
        let eq = equipmentdata.find((eqd) => eqd.id === equipment);
        if (eq) {
          let eqname = eq.name;

          let newptscript = {};
          newptscript.label = 'eq.' + eqname + "." + ptname;
          newptscript.type = 'variable';
          newptscript.info = '';
          newptscript.apply = "" + id;
          pointsscripttmp.push(newptscript);
        }
      }
    });
    let customFunctionstmp = customFunctions.concat(pointsscripttmp);
    console.log(customFunctionstmp);
    setCustomAutocomplete(javascriptLanguage.data.of({ autocomplete: completeFromList(customFunctionstmp) }));
  }, [fullpointdata, equipmentdata]);

  useEffect(() => {
    if (!name)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  useEffect(() => {
    if (wpgroup) {
      axios
        .get(
          getMBMAVOBBoxs(wpgroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let filteredavobboxs = res.data.avobboxs?.filter((obj) => obj.type === 3);
          let tmpBoxsData = filteredavobboxs.map((data) => {
            return (
              { name: data.name, id: data.id }
            );
          });
          setBoxdata(tmpBoxsData || []);
        });
    }
  }, [wpgroup]);

  const createScript = async (event) => {
    let newscript = {
      destination: {
        avobboxs,
        avobboxsupdate: avobboxs,
        destinationtype,
      },
      parameters: {
        name,
        description,

      },
      triggers,
      script: btoa(script),
    }
    axios
      .post(
        postGEBScript(workspaceid),
        newscript
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Script créé");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };

  const updateScript = async (event) => {
    let newscript = {
      ...currentScript,
      destination: {
        avobboxs,
        avobboxsupdate: avobboxs,
        destinationtype,
      },
      parameters: {
        ...currentScript.parameters,
        name,
        description,
      },
      triggers,
      script: btoa(script),
    }

    axios
      .put(
        putGEBScript(currentScript.id),
        newscript
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Script modifié");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };

  const testScript = async (isnew) => {
    let newscript = {};
    if (!isnew) {
      newscript = {
        ...currentScript,
        destination: {
          avobboxs,
          avobboxsupdate: avobboxs,
          destinationtype,
        },
        parameters: {
          ...currentScript.parameters,
          name,
          description,
        },
        triggers,
        script: btoa(script),
      }
    }
    else {
      newscript = {
        destination: {
          avobboxs,
          avobboxsupdate: avobboxs,
          destinationtype,
        },
        parameters: {
          name,
          description,

        },
        triggers,
        script: btoa(script),
        id: 1 //dont care, just need one
      }
    }

    axios
      .put(
        putGEBScript(currentScript.id, 'test'),
        newscript
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Script testé");
          console.log(res.data);
          let retour = res.data.retour;
          let text = "####RETOUR DU SCRIPT####\r\n\r\n";
          text += "Durée : " + retour.duration + "ms\r\n\r\n";
          text += "####VALEURS ECRITES####\r\n";
          retour.writenvalues.forEach((wv) => {
            text += "Id : " + wv.id + " | Valeur : " + wv.val + "\r\n";
          });
          text += "\r\n";
          text += "####CONSOLE####\r\n";
          text += retour.console;
          alert(text);
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={scriptText.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                required
              />
            </div>
            <div>
              <TextInput
                inputTitle={scriptText.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={"Destination"}
                selectValue={destinationtype}
                handleSelectValueChange={handleDestinationtypeChange}
                data={destinationData}
                disabled={!mbm_geb_control_schedules}
              />
            </div>
            {
              destinationtype === 'avobbox' ?
                <div>
                  <AutocompleteMultiselectInputById
                    specialWidth={"97%"}
                    inputMargin={"1rem 0rem 0rem"}
                    inputTitle={"AVOB Box concernées"}
                    selected={selectedBox()}
                    list={boxdata}
                    handleChange={handleBoxsChange}
                    disabled={!mbm_geb_control_schedules}
                  />
                </div> : <></>
            }

          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginTop: "20px", marginBottm: "10px" }}>
            <CodeMirror
              value={script}
              height="400px"
              extensions={[javascript({ jsx: false }), customAutocomplete]}
              onChange={onChange}
              theme="dark"
            />
          </GridItem>
        </GridContainer>
        {destinationtype !== 'avobbox' ?
          <Button
            disabled={buttonDisabled}
            className={
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.testButton
            }
            onClick={() => {
              handleTest();
            }}
          >
            Tester le script
          </Button> : <></>
        }
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default ScriptDialog;
